// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"W9PmmYoY","rightWrapper":"aQ6hJWTm","tooltipTitleLabel":"loNr5Qcl","categoryLabel":"cz2_vunS"};